import { render } from "./PaymentResultView.vue?vue&type=template&id=5f892b47&scoped=true"
import script from "./PaymentResultView.vue?vue&type=script&lang=js"
export * from "./PaymentResultView.vue?vue&type=script&lang=js"

import "./PaymentResultView.vue?vue&type=style&index=0&id=5f892b47&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f892b47"]])

export default __exports__